import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import { Center, Black, BlackHeading } from '../../../GeneralStyle'

import { LogeButtonSlim } from '../ActiveResidenceBookingsStyle';

@inject('residenceBookingStore', 'userStore')

@observer
class BookingError extends Component {
  close(){
    this.props.closeModal()
    this.props.residenceBookingStore.resetData(1)
  }
  render() {
    // const { me } = this.props.userStore
    //const { bookingDate } = this.props.ResidenceBookingStore
    //const mailContent = "?subject=Startzeit reservieren&body=Guten Tag,%0D%0A ich möchte für den " + bookingDate + " meine Startzeit <IHRE STARTZEIT> reservieren.%0D%0AMit freundlichen Grüßen,%0D%0A" + me.lastname
    // let iconSize = window.innerWidth < 769 ? window.innerWidth / 4 : 168

    return (
      <div style={{paddingTop: 35, paddingBottom: 35}}>
        <Center marginTop={30} marginBottom={30}>
          {/*<IconBig icon={successIcon} size={iconSize} margin={0} float={"none"} />*/}
        </Center>
        <Center marginTop={30} marginBottom={30}>
          <BlackHeading>Es tut uns leid, aber leider ist Ihre Buchung fehlgeschlagen.</BlackHeading>
        </Center>
            <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "45%", margin: '0 auto', marginBottom: 20 }}></div>
        <Row>
          <Center margin={45}>
            <Black>{this.props.residenceBookingStore.errorMessage}</Black>
          </Center>

          <Center marginTop={30} marginBottom={30}>
            <LogeButtonSlim
              hoverFontColor={"white"}
              onClick={() => { this.close() }}>
              schließen</LogeButtonSlim>
          </Center>
        </Row>
      </div>
    );
  }
}

BookingError.propTypes = {
  residenceBookingStore: MobxPropTypes.observableObject,
  userStore: MobxPropTypes.observableObject
};

export default BookingError;



// WEBPACK FOOTER //
// /src/components/internal/Residence/ResidenceBookingModal/ResidenceBookingError.js